import * as PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/default-skin/default-skin.css';
import * as PhotoswipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/dist/photoswipe.css';
import * as React from 'react';
import 'src/assets/less/index.less';
import I18N from 'src/services/I18NService';

interface IPswpComponentProps {
  onRef(obj: any): void;
}

export default class PswpComponent extends React.Component<IPswpComponentProps> {
  pswpElement: any;
  gallery: any;
  width: number;
  height: number;

  constructor(props: IPswpComponentProps) {
    super(props);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.closeGallery();
  }

  openGallery = (item: string) => {
    const items = [
      {
        src: item,
        w: 0,
        h: 0,
      },
    ];
    const pswpElement = this.pswpElement;
    const options = { index: 0 };
    this.gallery = new PhotoSwipe(pswpElement, PhotoswipeUIDefault, items, options);
    this.gallery.listen('gettingData', (index: number, itemSub: any) => {
      const thisSub = this;
      if (itemSub.w < 1 || itemSub.h < 1) {
        // unknown size
        const img = new Image();
        img.onload = () => {
          // will get size after load
          itemSub.w = itemSub.width; // set image width
          itemSub.h = itemSub.height; // set image height
          thisSub.gallery.invalidateCurrItems(); // reinit Items
          thisSub.gallery.updateSize(true); // reinit Items
        };
        img.src = itemSub.src; // let's download image
      }
    });
    this.gallery.init();
  };

  closeGallery = () => {
    if (!this.gallery) {
      return;
    }
    this.gallery.close();
  };

  render() {
    return (
      <div
        className="pswp"
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
        ref={div => {
          this.pswpElement = div;
        }}
      >
        <div className="pswp__bg" />
        <div className="pswp__scroll-wrap">
          <div className="pswp__container">
            <div className="pswp__item" />
            <div className="pswp__item" />
            <div className="pswp__item" />
          </div>
          <div className="pswp__ui pswp__ui--hidden">
            <div className="pswp__top-bar">
              <div className="pswp__counter" />
              <button className="pswp__button pswp__button--close" title={`${I18N.get('common_close')} (Esc)`} />
              {/* <button className="pswp__button pswp__button--share" title="Share" /> */}
              <button className="pswp__button pswp__button--fs" title={I18N.get('common_full_screen')} />
              <button className="pswp__button pswp__button--zoom" title={`${I18N.get('common_zoom_in')}/${I18N.get('common_zoom_out')}`} />
              <div className="pswp__preloader">
                <div className="pswp__preloader__icn">
                  <div className="pswp__preloader__cut">
                    <div className="pswp__preloader__donut" />
                  </div>
                </div>
              </div>
            </div>
            <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div className="pswp__share-tooltip" />
            </div>
            <button className="pswp__button pswp__button--arrow--left" title="Previous (arrow left)" />
            <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)" />
            <div className="pswp__caption">
              <div className="pswp__caption__center" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/PswpComponent.tsx